<template>
  <v-container fluid class="down-top-padding">
    <div id="sizesPage" class="page">
      <div class="page__header ">
        <Toolbar
          :showFiltersPanel="showFiltersPanel"
          @showFiltersPanelChanged="handleShowFiltersPanelChanged"
          @toggleDialog="toggleDialog"
        />
      </div>
      <div class="page__body pa-4">
        <div class="mb-4" v-show="showFiltersPanel">
          <v-row class="my-0">
            <v-col>
              <Filters @filtersChanged="handleFiltersChanged" />
            </v-col>
          </v-row>
        </div>

        <v-dialog v-model="dialog" persistent scrollable max-width="1000px">
          <Form
            v-if="dialog"
            @formSubmit="handleFormSubmit"
            :toggleDialog="toggleDialog"
            :isSubmittingForm="isSubmittingForm"
            :selectedSize="selectedSize"
          />
        </v-dialog>
        <List
          :page="page"
          :items="items"
          :totalCount="totalCount"
          :isFetchingItems="isFetchingItems"
          :itemsPerPage="itemsPerPage"
          @editItem="handleEditItem"
          @deleteItem="handleDeleteItem"
          @optionsChanged="handleOptionsChanged"
        />
      </div>
      <ConfirmationPopup
        id="size-delete-modal"
        v-if="sizeToDelete"
        title="Ölcünün silinməsi"
        :dialog="confirmationDialog"
        :loading="isDeletingSize"
        @confirm="handleDeleteConfirmation"
        @cancel="handleDeleteCancellation"
      >
        <span class="font-weight-bold">
          {{ sizeToDelete.name }}
        </span>
        ölcünü silmək istədiyinizə əminsiniz?
      </ConfirmationPopup>
    </div>
  </v-container>
</template>

<script>
import API from "@/services";
import ConfirmationPopup from "@/shared/Common/ConfirmationPopup.vue";
import bus from "../../../event-bus";
import List from "./components/List/index.vue";
import Form from "./components/Form/index.vue";
import Toolbar from "./components/Toolbar/index.vue";
import Filters from "./components/Toolbar/components/Filters.vue";

export default {
  components: {
    List,
    Form,
    Toolbar,
    ConfirmationPopup,
    Filters,
  },
  data() {
    return {
      dialog: false,
      confirmationDialog: false,
      selectedSize: null,
      sizeToDelete: null,
      page: 1,
      isFetchingItems: false,
      isSubmittingForm: false,
      isDeletingSize: false,
      totalCount: 0,
      itemsPerPage: 10,
      items: [],
      filters: {},
      sortedBy: null,
      sortedDesc: null,
      showFiltersPanel: false,
    };
  },
  async created() {
    this.fetchSizes();
  },
  methods: {
    fetchSizes() {
      this.isFetchingItems = true;
      API.fetchSizes({
        limit: this.itemsPerPage,
        offset: (this.page - 1) * this.itemsPerPage,
        sortedBy: this.sortedBy,
        sortedDesc: this.sortedDesc,
        ...this.filters,
      })
        .then((response) => {
          this.items = response.items;
          this.totalCount = response.totalCount;
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Ölçülərin siyahısını əldə etmək mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isFetchingItems = false;
        });
    },
    handleFormSubmit(formData) {
      this.isSubmittingForm = true;
      const request = this.selectedSize
        ? API.updateSize(this.selectedSize.id, formData)
        : API.insertSize(formData);

      request
        .then(() => {
          this.toggleDialog();
          this.fetchSizes();
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Əməliyyatı aparmaq mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isSubmittingForm = false;
        });
    },
    handleEditItem(item) {
      this.isFetchingItems = true;
      API.fetchSizeById(item.id)
        .then((response) => {
          this.selectedSize = response;
          this.dialog = true;
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Məlumatı əldə etmək mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isFetchingItems = false;
        });
    },
    handleDeleteItem(item) {
      this.sizeToDelete = item;
      this.confirmationDialog = true;
    },
    handleDeleteConfirmation() {
      this.isDeletingSize = true;
      API.deleteSize(this.sizeToDelete.id)
        .then(() => {
          this.confirmationDialog = false;
          this.sizeToDelete = null;
          this.fetchSizes();
        })
        .catch(() => {
          bus.$emit("notificationMessage", {
            color: "error",
            text: "Ölçünü silmək mümkün olmadı.",
          });
        })
        .finally(() => {
          this.isDeletingSize = false;
        });
    },
    handleDeleteCancellation() {
      this.confirmationDialog = false;
      this.sizeToDelete = null;
    },
    handleFiltersChanged(filters) {
      if (JSON.stringify(filters) !== JSON.stringify(this.filters)) {
        this.page = 1;
        this.filters = { ...filters };
        this.fetchSizes();
      }
    },
    toggleDialog() {
      this.dialog = !this.dialog;
      if (!this.dialog) {
        this.selectedSize = null;
      }
    },
    handleOptionsChanged(item) {
      if (
        this.sortedBy !== item.sortedBy ||
        this.sortedDesc !== item.sortedDesc ||
        this.page !== item.page ||
        this.itemsPerPage !== item.itemsPerPage
      ) {
        this.page = item.page;
        this.itemsPerPage = item.itemsPerPage;
        this.sortedBy = item.sortedBy;
        this.sortedDesc = item.sortedDesc;
        this.fetchSizes();
      }
    },
    handleShowFiltersPanelChanged(item) {
      this.showFiltersPanel = item;
    },
  },
};
</script>
